var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "timePicker" } },
    [
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", lazy: "", "full-width": "", width: "290px" }
        },
        [
          _c(
            "v-icon",
            {
              staticClass: "icon",
              attrs: { slot: "activator" },
              slot: "activator"
            },
            [_vm._v("mdi-clock")]
          ),
          _vm._v(" "),
          _c("v-time-picker", {
            attrs: { scrollable: "", color: "primary", actions: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var save = ref.save
                  var cancel = ref.cancel
                  return [
                    _c(
                      "v-btn",
                      {
                        attrs: { flat: "", color: "primary" },
                        on: { click: cancel }
                      },
                      [_vm._v("Cancel")]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        attrs: { flat: "", color: "primary" },
                        on: { click: _vm.timePickerChanged }
                      },
                      [_vm._v("Save")]
                    )
                  ]
                }
              }
            ]),
            model: {
              value: _vm.timePicker,
              callback: function($$v) {
                _vm.timePicker = $$v
              },
              expression: "timePicker"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("v-text-field", {
        staticClass: "input",
        attrs: { label: _vm.label, mask: "time" },
        on: { change: _vm.textFieldChanged },
        model: {
          value: _vm.textField,
          callback: function($$v) {
            _vm.textField = $$v
          },
          expression: "textField"
        }
      }),
      _vm._v(" "),
      _c("div", { on: { click: _vm.amChanged } }, [
        _vm._v(_vm._s(_vm.am ? "AM" : "PM"))
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0861fe6b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0861fe6b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TimePicker.vue
// module id = 620
// module chunks = 4